import { Injectable } from "@angular/core";
import { Headers } from "@angular/http";
import { SessionService } from "./session.service";

@Injectable()
export class ConnectionService {
  private headers: Headers;
  constructor(private sessionService: SessionService) {}

  GetAuthorizationHeader(company: string = null): Headers {
    this.headers = new Headers();
    this.headers.append("Content-Type", "application/json");
    this.headers.append(
      "Authorization",
      "Bearer " + this.sessionService.getSessionToken()
    );
    if (company == null) {
      this.headers.append("company", this.sessionService.getSelectedCompany());
    } else {
      this.headers.append("company", company);
    }
    return this.headers;
  }

  GetAuthorizationHeaderFromToken(token: string, company: string = null): Headers {
    this.headers = new Headers();
    this.headers.append("Content-Type", "application/json");
    this.headers.append("Authorization", "Bearer " + token);
    if (company == null) {
      this.headers.append("company", this.sessionService.getSelectedCompany());
    } else {
      this.headers.append("company", company);
    }
    return this.headers;
  }

  GetFileAuthorizationHeader() {
    this.headers = new Headers();
    this.headers.append("Content-Type", "multipart/form-data");
    this.headers.append(
      "Authorization",
      "Bearer " + this.sessionService.getSessionToken()
    );
    this.headers.append("company", this.sessionService.getSelectedCompany());
    return this.headers;
  }

  GetFileWithBoundaryAuthorizationHeader(companyRef: string = "") {
    this.headers = new Headers();
    this.headers.append(
      "Authorization",
      "Bearer " + this.sessionService.getSessionToken()
    );
    this.headers.append(
      "company",
      companyRef === "" ? this.sessionService.getSelectedCompany() : companyRef
    );
    return this.headers;
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/connection.service.ts